/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/accordion.css'
import './styles.scss'
import './disco_changes.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Image, Link, UpdateNote } from '@ta-interaktiv/contentbricks'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'
import { Accordion } from 'semantic-ui-react'
import Tab from 'components/tab'

import { qanda } from './qa'
// console.log(qanda)
// TODO Set the correct article ID here
const ARTICLE_ID = '533675517866'
const isMobile = window.innerWidth < 600

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      activeIndex: [-1]
    }
  }

  handleClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    // const newIndex = activeIndex === index ? -1 : index
    // this.setState({ activeIndex: newIndex })
    const openIndex = activeIndex.indexOf(index)
    console.log('openIndex: ', openIndex)
    if (openIndex === -1) {
      const newArray = this.state.activeIndex.slice()
      newArray.push(index)
      this.setState({ activeIndex: newArray })
    } else {
      const newArray = this.state.activeIndex
      newArray.splice(openIndex, 1)
      this.setState({ activeIndex: newArray })
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'toggle tab: ' + titleProps.index
    })
  }

  render() {
    return (
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} />
        <ThemeSwitch />

        {/* TODO Replace the following segment with your project cover */}
        <header className='ui vertical fitted segment'>
          <div className='ui container'>
            <h1 className='ui image header'>
              <div className='content'>
                Welche Masken schützen und wie man sie richtig trägt
                <div className='sub header lead'>
                  Bald werden wir auch in der Schweiz vermehrt Schutzmasken
                  tragen. Alles, was Sie dazu wissen müssen, finden Sie in
                  unserer visuellen Übersicht.
                </div>
              </div>
            </h1>
          </div>
        </header>

        {/* TODO And probably remove the following segment and replace it with
       your own content */}
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ta metainfo'>
              <div className='ta author'>
                Patrick Vögeli, Alexandra Bröhm, Sebastian Broschinski, Marc
                Brupbacher
              </div>
              <div className='ta updated'>Aktualisiert am 1. Juli 2020</div>
            </div>

            <p>
              Masken ja oder nein, über diese Frage diskutieren wir in der
              Schweiz seit Monaten. Nun endlich wurde ein Entscheid gefällt. Ab
              Montag gilt im öffentlichen Verkehr eine Maskenpflicht. Das hat
              der Bundesrat beschlossen. Er reagiert damit auf die steigenden
              Corona-Fallzahlen und die Forderung der Kantone. Nach der
              Aufhebung der Massnahmen zur Bekämpfung der Coronavirus-Pandemie
              seien wieder mehr Menschen mit dem öffentlichen Verkehr unterwegs.
              Dabei könne der empfohlene Abstand oft nicht eingehalten werden.
            </p>
            <p>
              Die Maskenpflicht gilt für Personen ab zwölf Jahren. Sie gilt in
              Zügen, Trams und Bussen, Bergbahnen, Seilbahnen und auf Schiffen.
              Wir zeigen, was es zu beachten gilt.
            </p>
          </div>
        </div>
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <h3>
              <div className='qnumber'>1</div>Die grössten Fehler
            </h3>
            <p style={{ marginBottom: '2rem' }}>
              Den meisten Menschen wird das Tragen der Maske schnell unangenehm.
              Sie beginnen dann, daran herumzuzupfen und sie hoch- oder
              runterzuziehen. Das sollte man keinesfalls tun. Wenn man sich dazu
              entschliesst, eine Maske zu tragen, sollte man sie nicht anfassen.
              Wer die Maske immer wieder an- und auszieht, ohne sich vorher die
              Hände zu desinfizieren, kann genauso gut keine tragen.
              Diszipliniert zu bleiben, ist nicht einfach. Korrekt angewendet,
              können Masken aus Sicht verschiedener Experten aber eine wichtige
              Rolle bei der Eindämmung spielen.
            </p>

            <Fails
              direction='left'
              imgSrc='fail_1.png'
              text='Die Maske sollte immer die ganze Nase bedecken.'
            />
            <Fails
              direction='right'
              imgSrc='fail_2.png'
              text='Auch das Kinn sollte immer vollständig bedeckt sein.'
            />

            <Fails
              direction='left'
              imgSrc='fail_3.png'
              text='Die Maske darf nicht locker über den Ohren hängen, sondern muss festgezurrt werden.'
            />

            <Fails
              direction='right'
              imgSrc='fail_4.png'
              text='Die Maske sollte man zur Entlastung nie unter das Kinn schieben.'
            />
          </div>
          {/* <div className='ui vertical segment'> */}
          <div className='ui text container'>
            <div className='smallTitle center'>So geht es!</div>
            <Fails
              direction='center'
              imgSrc='correct.png'
              text='Die Maske sollte die ganze Nase und auch das Kinn vollständig bedecken. Die Maske muss so festgezogen werden, dass sie eng am Gesicht liegt, es darf keine Lücken geben.'
              correct
            />

            <div className='list'>
              <div className='smallTitle'>Das gilt es weiter zu beachten:</div>
              <ul>
                <li>
                  Waschen Sie Ihre Hände gründlich.{' '}
                  <Link href='https://interaktiv.tagesanzeiger.ch/2020/richtig-haendewaschen/?nosome'>
                    Hier erfahren Sie wie.
                  </Link>
                </li>
                <li>
                  Ziehen Sie die Maske an, bevor Sie die Wohnung verlassen.
                </li>
                <li>
                  Halten Sie die Maske am oberen und unteren Ende fest und
                  platzieren Sie sie über Nase und Mund. Ziehen Sie die Bänder
                  über die Ohren und spannen Sie die Maske so an, dass es keine
                  Lücken zwischen Maske und Gesicht mehr gibt.
                </li>
                <li>
                  Fassen Sie die Vorderseite der Maske nicht an. Wenn es doch
                  passiert, müssen Sie erneut die Hände waschen.
                </li>
                <li>
                  Sobald die Maske durchfeuchtet ist, sollte sie gewechselt
                  werden, spätestens nach sechs bis acht Stunden. Um die Maske
                  abzusetzen, sollte man sie hinten an den Bändern lösen, auf
                  keinen Fall vorne am Schutzvlies. Danach in einem Mülleimer
                  mit Deckel entsorgen. Waschen Sie Ihre Hände erneut gründlich.
                </li>
                <li>
                  Nur weil Sie eine Maske tragen, sollten Sie sich nicht zu
                  sicher fühlen. Die Hygieneregeln und das Social Distancing
                  sind trotzdem noch genauso wichtig.
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* </div> */}
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <h3>
              <div className='qnumber'>2</div>Welche Maskentypen gibt es
            </h3>
            <div className='smallTitle'>
              Atemschutzmasken (Mit und ohne Ventil)
            </div>
            <div className='smallSubtitle'>FFP1, FFP2, FFP3</div>
            <img
              className='masktype'
              src={require('images/atemschutzmaske.jpg')}
            />
            <div className='list'>
              <ul className='maskList'>
                <li>
                  Die Bezeichnung FFP steht für Filtering Face Piece. FFP1, FFP2
                  und FFP3 schützen zu 80, 94 bzw. 99 Prozent vor Viren - ganz
                  dicht sind sie aber nicht. FFP1-Masken schützen nicht vor
                  Aerosolen und sind für den Selbstschutz im medizinischen
                  Bereich ungeeignet.
                </li>
                <li>
                  Mit FFP2/3-Masken schützen sich die Träger, zum Beispiel
                  Pfleger oder Ärztin, vor Infektionen, da die Atemluft von
                  aussen gefiltert wird beim Einatmen.
                </li>
                <li>
                  Partikelfilter fangen auch Staub, Dämpfe oder einen Teil
                  Mikroorganismen auf.
                </li>
                <li>
                  Achtung: Einige dieser Masken haben ein Ventil zum leichteren
                  Ausatmen. Infizierte Personen mit oder ohne Krankheitssymptome
                  sollen diese Masken nicht benutzen, denn sie tragen zur
                  Virenverbreitung bei.
                </li>
                <li>
                  Die Schutzwerte gelten nur, wenn die Maske optimal sitzt, so
                  können bereits «Barthaare im Bereich der Dichtlinie zwischen
                  Atemschutzmaske und Gesichtshaut die Schutzwirkung
                  beeinträchtigen», wie das Robert-Koch-Institut betont.
                </li>
              </ul>
            </div>
            <div className='smallTitle'>
              Hygienemasken oder chirurgische Maske
            </div>
            <div className='smallSubtitle'>Typ II oder IIR</div>{' '}
            <img
              className='masktype'
              src={require('images/hygienemaske.jpg')}
            />
            <div className='list'>
              <ul className='maskList'>
                <li>
                  Innenseite der meisten medizinischen Masken sind weiss,
                  während die Aussenseite eine beliebige andere Farbe aufweist.
                </li>
                <li>
                  Für Personen mit Krankheitssymptomen gedacht. Sie schützen das
                  Umfeld vor infektiösen Erregern aus Nase und Mund des
                  Maskenträgers. Können also das Infektionsrisiko bei älteren
                  und chronisch kranken Menschen reduzieren.
                </li>
                <li>
                  Bieten keinen zuverlässigen Schutz gegen eine Infektion, da
                  sie keinen Filter besitzen und an den Rändern viel Luft
                  eingesogen wird.
                </li>
                <li>
                  Verhindern, dass Schleimhäute von Mund und Nase mit allfällig
                  verseuchten Händen berührt werden.
                </li>
                <li>
                  Metallstück über der Nase zu Beginn satt andrücken, damit die
                  Maske dicht sitzt.
                </li>
                <li>
                  Nach einmaligem Gebrauch sofort wegwerfen und danach Hände mit
                  Wasser und Seife waschen.
                </li>
              </ul>
            </div>
            <div className='smallTitle'>Stoffmasken</div>
            <img className='masktype' src={require('images/diymaske.jpg')} />
            <div className='listSubTitle'>Selbst gemachte Stoffmasken</div>
            <div className='list'>
              <ul className='maskListSpecial'>
                <li>
                  Wer keine Masken kaufen kann, der kann sich auch selbst eine
                  Maske aus Stoff nähen oder basteln.
                </li>
                <li>
                  Am besten nimmt man ein Material wie Baumwolle, das sich gut
                  heiss waschen lässt. Idealerweise ist die Maske mehrlagig.
                </li>
                <li>
                  Für die Stoffmasken gilt, was auch bei den Hygienemasken gilt:
                  Sie schützen weniger einen selbst vor einer Ansteckung,
                  sondern das Umfeld in einem gewissen Mass.
                </li>
                <li>
                  Im Netz findet man{' '}
                  <Link href='https://www.sueddeutsche.de/kultur/corona-schnittmuster-maske-naehen-1.4867096'>
                    Anleitungen
                  </Link>
                  , um eine Maske{' '}
                  <Link href='https://www.sueddeutsche.de/kultur/masken-naehen-coronavirus-design-schnittmuster-gesichtsmaske-1.4868250'>
                    selbst
                  </Link>{' '}
                  zu machen. Es gibt sogar Anleitungen für alle, die{' '}
                  <Link href='https://www.chip.de/news/Mundschutz-selber-basteln-so-gehts_182587291.html'>
                    nicht
                  </Link>{' '}
                  gerne nähen.
                </li>
                <li>
                  Werden vom Bundesamt für Gesundheit und der Swiss National
                  Covid-19 Science Task Force nicht empfohlen, da sie keine
                  nachgewiesene Schutzwirkung aufweisen.
                </li>
              </ul>
            </div>
            <div className='listSubTitle'>Geprüfte Textilmasken</div>
            <div className='list'>
              <ul className='maskList'>
                <li>
                  Geprüfte industriell gefertigte Textilmasken verschiedener
                  Schweizer Unternehmen. Erhältlich seit mitte Mai.
                </li>
                <li>
                  Erfüllen die Anforderungen der{' '}
                  <Link href='https://ncs-tf.ch/de/policy-briefs/community-mask-spec-and-recommendations-25-april-20-en-2'>
                    National Covid-19 Science Task Force
                  </Link>
                  .
                </li>
                <li>Tragen das Label «TESTEX Community Mask».</li>
                <li>
                  Die Qualitätsstandards für die geprüften Textilmasken haben
                  Empa-Forschende zusammen mit der Schweizer Textilbranche
                  entwickelt.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className='ui vertical segment qa'>
          <div className='ui text container'>
            <h3>
              <div className='qnumber'>3</div>Die wichtigsten Fragen und
              Antworten
            </h3>

            <Accordion fluid styled>
              {qanda.map((q, index) => (
                <>
                  {isMobile && (
                    <div className={'qaList' + index}>
                      <Tab
                        activeIndex={this.state.activeIndex}
                        index={index}
                        handleClick={this.handleClick}
                        title={q.q}
                        // flag={q.n}
                        articleId={ARTICLE_ID}
                      >
                        {/* <div className='question'>{q.q}</div> */}
                        {q.a}
                      </Tab>
                    </div>
                  )}
                  {!isMobile && <QandA q={q} />}
                </>
              ))}
            </Accordion>
          </div>
        </div>
        {/* TODO Add your credits in this component */}
        <Footer
          articleId={ARTICLE_ID}
          questions={[
            'Wie informativ war der Beitrag?',
            'Wie gefällt Ihnen die Gestaltung?'
          ]}
          credits={[
            [
              'Konzept und Umsetzung',
              'Patrick Vögeli, Alexandra Bröhm, Sebastian Broschinski, Marc Brupbacher'
            ]
          ]}
        >
          <div
            className='ui container'
            style={{ margin: isMobile ? '1.2em 0 3em' : '0 0 3em' }}
          >
            <h4 className='teaser'>Weitere Beiträge zum Thema</h4>
            <ArticleTeasers
              numberOfCards='three'
              articleIds={[
                '714702734144',
                '201785945001',
                '18727947',
                '172597671179',
                '448154497109',
                '370164650671',
                '29899036',
                '19483314',
                '15650041',
                '468580919994'
              ]}
            />
          </div>
        </Footer>
      </div>
    )
  }
}

const QandA = ({ q }) => (
  <div className='qa'>
    <div className='question'>{q.q}</div>
    <div className='answer'>{q.a}</div>
  </div>
)

const Fails = ({
  direction,
  imgSrc,
  text,
  correct
}: {
  direction: string
  imgSrc: string
  text: string
  correct?: boolean
}) => (
  <>
    <div className={'failWrapper ' + direction}>
      <div className='roundImage'>
        <img src={require('images/' + imgSrc)} />
      </div>

      <div className='text'>
        <div className={correct ? 'correct' : 'wrong'}>
          <i className={correct ? 'icon check' : 'icon times'} />
          {correct ? 'Richtig!' : 'Falsch!'}
        </div>
        {text}
      </div>
    </div>
  </>
)
